import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import { Form } from "antd";
import type { FormInstance } from "antd";
import type { PurchaseContractFormValues } from "../type";
import { BasicContractFormFields } from "./BasicContractFormFields";
import { useInitFormValues } from "../hooks/useInitFormValues";
import { ApplicantFormFields } from "./ApplicantFormFields";
import { ContractReviewFormFields } from "./ContractReviewFormFields";
import { CheckListFormFields } from "./checklist/CheckListFormFields";
import { ContractFileFormFields } from "./ContractFileFormFields";
import { useModal } from "@/hooks/modals/useModal";
import { useContractRecordQuery } from "../hooks/useContractRecordQuery";
import { useFormEditable } from "../hooks/useFormEditable";
import { useContractFlowNodeMatcher } from "../hooks/useContractFlowNodeMatcher";

type Props = {
  form: FormInstance<PurchaseContractFormValues>;
};

export const PurchaseContractForm = ({ form }: Props) => {
  const { props } = useModal("PURCHASE_CONTRACT");

  const { recordId } = props;

  const detail = useContractRecordQuery(recordId);
  const isSupplierContractUpload = detail?.contractUploader === "供应商";

  useInitFormValues(form, detail);

  const { isMatchPendingSupplierUploadNode, isMatchConfirmContractNode } =
    useContractFlowNodeMatcher(detail?.insId);

  const { isMainFormDisabled } = useFormEditable();

  return (
    <Form disabled={isMainFormDisabled} form={form} layout="vertical">
      {/* 创建人信息 */}
      {!isSupplierContractUpload && <UserFormFields />}

      {/* 基本合同信息 */}
      <BasicContractFormFields />

      {/* 申请人信息 */}
      <ApplicantFormFields />

      {/* 合同审查信息 */}
      <ContractReviewFormFields />

      {/* 合同检查项 */}
      <CheckListFormFields />

      {/* 合同文件信息 */}
      <ContractFileFormFields
        isMatchPendingSupplierUploadNode={isMatchPendingSupplierUploadNode}
        isMatchConfirmContractNode={isMatchConfirmContractNode}
      />
    </Form>
  );
};
